import clsx from 'clsx'
import {
  reportCard,
  reportCardPad,
  reportCardSub,
  reportCardTitle,
  reportEyebrow,
  reportSegment,
  reportSegmentBtn,
} from '../reports/ui'

/** Re-export Reports recipes so the full-page details surface stays in lockstep. */
export {
  reportCard,
  reportCardPad,
  reportCardSub,
  reportCardTitle,
  reportEyebrow,
  reportSegment,
  reportSegmentBtn,
}

export const detailShell =
  'flex h-full min-h-0 flex-col overflow-hidden rounded-xl border border-slate-200/80 bg-slate-50 shadow-sm ring-1 ring-gray-900/5'

export const detailHeader =
  'sticky top-0 z-10 flex shrink-0 flex-wrap items-center gap-3 border-b border-slate-200/80 bg-white/95 px-4 py-3 backdrop-blur'

export const detailGhostBtn =
  'inline-flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium text-slate-600 ring-1 ring-slate-200 transition-colors hover:bg-slate-50 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600'

export const detailPrimaryBtn =
  'inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-medium text-white shadow-sm transition-colors hover:bg-slate-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600'

export function detailDangerBtn(active: boolean): string {
  return clsx(
    'inline-flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors',
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600',
    active
      ? 'bg-rose-50 text-rose-800 ring-1 ring-rose-200 hover:bg-rose-100'
      : 'text-slate-600 ring-1 ring-slate-200 hover:bg-slate-50 hover:text-slate-900',
  )
}

/** Extra card chrome for VehicleCard / GeofenceCard when they sit on the full-page grid. */
export const detailGridCard =
  'rounded-xl shadow-sm ring-1 ring-gray-900/5 hover:translate-y-0 hover:shadow-sm'
